import { render, staticRenderFns } from "./BrFilter.vue?vue&type=template&id=7e7fa9f1&scoped=true"
import script from "./BrFilter.vue?vue&type=script&lang=js"
export * from "./BrFilter.vue?vue&type=script&lang=js"
import style0 from "./BrFilter.vue?vue&type=style&index=0&id=7e7fa9f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7fa9f1",
  null
  
)

export default component.exports